import React, { Component, FormEvent } from 'react';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import MessageUtil from '../../../../../util/MessageUtil';
import FormicaInput from 'components/custom/FormicaInput';
import RoleHelper from '../../../../../RoleHelper';
import { AnimatedButton } from '@trlogic/ui-pack';
import ComponentName from '../../../../../constant/ComponentName';
import LanguageUtil from '../../../../../util/LanguageUtil';

class ApiHeadersCreatorComponent extends Component<Props, State> {
  public state = new State();

  render() {
    const { parameter } = this.state;
    return (
      <div className={'flex w-full gap-x-4 items-center justify-start mb-5 px-1'}>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e) => this.onKeyChange(e)}
            value={parameter.key}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.key', defaultMessage: 'Key' })}
            data-testid={`${ComponentName.API_VARIABLE}_header_creator_key_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e) => this.onValueChange(e)}
            value={parameter.value}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.value', defaultMessage: 'Value' })}
            data-testid={`${ComponentName.API_VARIABLE}_header_creator_value_input`}
          />
        </div>
        <div className={'w-1/3'}>
          <FormicaInput
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onChange={(e) => this.onDescriptionChange(e)}
            value={parameter.description}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.description', defaultMessage: 'Description' })}
            data-testid={`${ComponentName.API_VARIABLE}_header_creator_description_input`}
          />
        </div>
        <div className={''}>
          <AnimatedButton
            disabled={!RoleHelper.canEdit('EnrichmentApi')}
            onClick={this.handleSubmit}
            customSize={'sm'}
            icon={'add'}
            customType={'primary'}
            text={LanguageUtil.get({ id: 'common.button.add', defaultMessage: 'Add' })}
            data-testid={`${ComponentName.API_VARIABLE}_header_creator_button`}
          />
        </div>
      </div>
    );
  }

  private onKeyChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, key: e.currentTarget.value } });
  };
  private onValueChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, value: e.currentTarget.value } });
  };
  private onDescriptionChange = (e: FormEvent<HTMLInputElement>) => {
    this.setState({ parameter: { ...this.state.parameter, description: e.currentTarget.value } });
  };
  private handleSubmit = () => {
    const { parameter } = this.state;
    const {
      apiVariable: { apiVariable },
      changeApiVariable,
    } = this.props;
    if (apiVariable.headers[parameter.key]) {
      MessageUtil.warning({
        summary: 'Header with this key already exists',
        detail: <div>{parameter.key} can't added.</div>,
      });
      return false;
    }
    apiVariable.headers = { ...apiVariable.headers, [parameter.key]: parameter.value };
    changeApiVariable(apiVariable);
    this.setState({ parameter: { ...this.state.parameter, key: '', value: '', description: '' } });
  };
}

interface Props extends ReduxProps {}

interface Parameter {
  key: string;
  value: string;
  description: string;
}

class State {
  parameter: Parameter = {
    key: '',
    value: '',
    description: '',
  };
}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
  isUpdate: state.apiVariable.isUpdate,
});

const mapDispatchToProps = { changeApiVariable };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ApiHeadersCreatorComponent);
